
  (function ($) {
    'use strict';

    if (!customElements.get('tyre-search-by-make')) {
      customElements.define(
        'tyre-search-by-make',
        class TyreSearchByMake extends HTMLElement {
          constructor() {
            super();
            this.urlPath = '';
            this.make = document.querySelector('.select-vehicle-make');
            this.make.addEventListener('change', this.getModel.bind(this));
            this.vehicleImage = document.getElementById('vehicle-image');
            this.modelDone = '';

            this.model = document.querySelector('.select-vehicle-model');
            this.model.addEventListener('change', this.finalModel.bind(this));
            this.modelFinal = '';

            this.formId = document.getElementById('the-form-by-make');
            this.initVehicleSearch();
          }

          initVehicleSearch() {
            axios
              .get(`/collections/all?view=ajax`)
              .then((response) => {
                let parser = new DOMParser();
                const dataParce = parser.parseFromString(response.data, 'text/html');
                const dataParceTarget = dataParce.querySelector('.select-vehicle-brand-result');
                let newMake = [];

                for (var i = 0, n = dataParceTarget.options.length; i < n; i++) {
                  if (dataParceTarget.options[i].value) newMake.push(dataParceTarget.options[i].value.trim());
                }

                newMake.sort();

                let uniqueArray = newMake.filter(function (item, pos, self) {
                  return self.indexOf(item) == pos;
                });

                var newMakeOp = '<option value="' + 'select' + '">' + 'select' + '</option>';
                uniqueArray.forEach((option) => {
                  newMakeOp += '<option value="' + option + '">' + option + '</option>';
                });
                this.make.innerHTML = newMakeOp;
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally(() => {
                // your finally code here
              });
          }

          getModel(evt) {
            let selectMake = this.make.options[this.make.selectedIndex].value.trim();
            console.log(selectMake);
            

           
            if (selectMake == 'select') {
              this.model.disabled = true;
            } else {

              this.getVehicleImageSource(selectMake)
              .then(imageSource => {
        
                this.vehicleImage.src = imageSource;
              })
              .catch(error => {
                console.error('Error fetching vehicle image:', error);

                this.vehicleImage.src = '//tyremart.com.bd/cdn/shop/t/20/assets/car-placeholder.svg?v=40177331278519666771781539728';
              });
              this.modelDone = selectMake;
              this.urlPath = `/collections/all?filter.p.m.product_details.make=${selectMake}`;
              this.formId.setAttribute('href', this.urlPath);
              axios
                .get(`/collections/all?filter.p.m.product_details.make=${selectMake}&view=ajax`)
                .then((response) => {
                  let parser = new DOMParser();
                  const data = parser.parseFromString(response.data, 'text/html');
                  const dataParceTarget = data.querySelector('.select-vehicle-model-result');
                  console.log(dataParceTarget);

                  let newModel = [];
                  // for (var i = 0, n = dataParceTarget.options.length; i < n; i++) {
                  //   if (dataParceTarget.options[i].value) newModel.push(dataParceTarget.options[i].value);
                  // }

                  for (var i = 0, n = dataParceTarget.options.length; i < n; i++) {
                          let optionValue = dataParceTarget.options[i].value;
                          if (optionValue.startsWith(selectMake)) {
                              newModel.push(optionValue);
                          }
                      }

                  newModel.sort();


                  let uniqueArray = newModel.filter(function (item, pos, self) {
                    return self.indexOf(item) == pos;
                  });
                  var newModelRen = '<option value="' + 'select' + '">' + 'select' + '</option>';
                  uniqueArray.forEach((option) => {
                    newModelRen += '<option value="' + option + '">' + option + '</option>';
                  });

                  this.model.innerHTML = newModelRen;
                  this.model.disabled = false;
                })
                .catch(function (error) {
                  console.log(error);
                })
                .finally(() => {
                  // your finally code here
                });
            }
          }

          finalModel(evt) {
            evt.preventDefault();
            let selectModel = this.model.options[this.model.selectedIndex].value;
            this.modelFinal = selectModel;
            this.urlPath = `/collections/all?filter.p.m.product_details.make=${this.modelDone}&filter.p.m.product_details.model=${selectModel}`;
            this.formId.setAttribute('href', this.urlPath);
            if (selectModel != 'select') {
              this.make.disabled = false;
              this.model.disabled = false;
            } else {
              this.make.disabled = false;
              this.model.disabled = false;
            }
          }

          getVehicleImageSource(brand) {
          const new_brand = brand.toLowerCase().trim();
          let assetUrl;

          if (new_brand === 'bmw') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-bmw.svg?v=119635416778862913641781539728";
          } else if (new_brand === 'mercedes') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-mercedes.svg?v=7339";
          } else if (new_brand === 'audi') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-audi.svg?v=7339";
          } else if (new_brand === 'toyota') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-toyota.svg?v=132890671289006015131781539728";
          } else if (new_brand === 'honda') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-honda.svg?v=7339";
          } else if (new_brand === 'ford') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-ford.svg?v=7339";
          } else if (new_brand === 'chevrolet') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-chevrolet.svg?v=7339";
          } else if (new_brand === 'nissan') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-nissan.svg?v=116478393225937374021781539728";
          } else if (new_brand === 'volkswagen') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-volkswagen.svg?v=158195485802076311571781539728";
          } else if (new_brand === 'hyundai') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-hyundai.svg?v=46104929437870116161781539728";
          } else if (new_brand === 'kia') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-kia.svg?v=21425374268845948901781539728";
          } else if (new_brand === 'mazda') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-mazda.svg?v=133247695720220161951781539728";
          } else if (new_brand === 'subaru') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-subaru.svg?v=7339";
          } else if (new_brand === 'porsche') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-porsche.svg?v=7339";
          } else if (new_brand === 'jeep') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-jeep.svg?v=7339";
          } else if (new_brand === 'dodge') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-dodge.svg?v=7339";
          } else if (new_brand === 'chrysler') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-chrysler.svg?v=7339";
          } else if (new_brand === 'ram') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-ram.svg?v=7339";
          } else if (new_brand === 'gmc') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-gmc.svg?v=7339";
          } else if (new_brand === 'cadillac') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-cadillac.svg?v=7339";
          } else if (new_brand === 'buick') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-buick.svg?v=7339";
          } else if (new_brand === 'lincoln') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-lincoln.svg?v=7339";
          } else if (new_brand === 'lexus') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-lexus.svg?v=170023385598675309051781539728";
          } else if (new_brand === 'infiniti') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-infiniti.svg?v=7339";
          } else if (new_brand === 'acura') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-acura.svg?v=7339";
          } else if (new_brand === 'volvo') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-volvo.svg?v=7339";
          } else if (new_brand === 'jaguar') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-jaguar.svg?v=7339";
          } else if (new_brand === 'land rover') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-land-rover.svg?v=7339";
          } else if (new_brand === 'maserati') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-maserati.svg?v=7339";
          } else if (new_brand === 'ferrari') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-ferrari.svg?v=7339";
          } else if (new_brand === 'lamborghini') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-lamborghini.svg?v=7339";
          } else if (new_brand === 'bugatti') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-bugatti.svg?v=7339";
          } else if (new_brand === 'tesla') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-tesla.svg?v=7339";
          } else if (new_brand === 'lotus') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-lotus.svg?v=7339";
          } else if (new_brand === 'aston martin') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-aston-martin.svg?v=7339";
          } else if (new_brand === 'rolls-royce') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-rolls-royce.svg?v=7339";
          } else if (new_brand === 'bentley') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-bentley.svg?v=7339";
          } else if (new_brand === 'alfa romeo') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-alfa-romeo.svg?v=7339";
          } else if (new_brand === 'fiat') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-fiat.svg?v=7339";
          } else if (new_brand === 'mini') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-mini.svg?v=33133396464299290001781539728";
          } else if (new_brand === 'smart') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-smart.svg?v=7339";
          } else if (new_brand === 'suzuki') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-suzuki.svg?v=65510584825171417261781539728";
          } else if (new_brand === 'mitsubishi') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-mitsubishi.svg?v=26462675933792206041781539728";
          } else if (new_brand === 'renault') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-renault.svg?v=1610615579958118871781539728";
          } else if (new_brand === 'peugeot') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-peugeot.svg?v=155234472141651451841781539728";
          } else if (new_brand === 'citroen') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-citroen.svg?v=137154921882983586371781539728";
          } else if (new_brand === 'opel') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-opel.svg?v=7339";
          } else if (new_brand === 'seat') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-seat.svg?v=7339";
          } else if (new_brand === 'skoda') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-skoda.svg?v=7339";
          } else if (new_brand === 'dacia') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-dacia.svg?v=7339";
          } else if (new_brand === 'saab') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-saab.svg?v=7339";
          } else if (new_brand === 'hummer') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-hummer.svg?v=7339";
          } else if (new_brand === 'saturn') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-saturn.svg?v=7339";
          } else if (new_brand === 'plymouth') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-plymouth.svg?v=7339";
          } else if (new_brand === 'oldsmobile') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-oldsmobile.svg?v=7339";
          } else if (new_brand === 'pontiac') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-pontiac.svg?v=7339";
          } else if (new_brand === 'mercury') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-mercury.svg?v=7339";
          } else if (new_brand === 'eagle') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-eagle.svg?v=7339";
          } else if (new_brand === 'amc') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-amc.svg?v=7339";
          } else if (new_brand === 'geo') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-geo.svg?v=7339";
          } else if (new_brand === 'daewoo') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-daewoo.svg?v=7339";
          } else if (new_brand === 'isuzu') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-isuzu.svg?v=7339";
          } else if (new_brand === 'sabaru') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-subaru.svg?v=7339";
          } else if (new_brand === 'scion') {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-brand-scion.svg?v=7339";
          } else {
            assetUrl = "//tyremart.com.bd/cdn/shop/t/20/assets/car-placeholder.svg?v=40177331278519666771781539728";
          }

          return fetch(`${assetUrl}`)
            .then((response) => {
             
              if (!response.ok) {
                throw new Error(`Failed to fetch image for ${new_brand}`);
              }
              return response.url;
            });
        }

        }
      );
    }
  })(window.jQuery);

